<template>
  <div class="authorization">
    <div class="title">
      公司资质管理 <span>授权审核</span>
    </div>
    <div class="main">
      <div class="authorizationInfo">授权审核</div>

      <div class="author_table">
        <div class="author_btn">
          <el-button @click="handleCancelClick">取消</el-button>
          <el-button @click="handleConfirmClick">保存</el-button>
        </div>
        <!-- 物流公司 -->
        <el-table :data="data.result">
          <el-table-column class-name="number"
                           label="序号"
                           align="center"
                           type="index"
                           min-width="40">
          </el-table-column>
          <el-table-column class-name="companyName"
                           prop="companyName"
                           label="公司名称"
                           header-align="center"
                           align="center">
          </el-table-column>
          <el-table-column prop="userName"
                           label="注册账号"
                           header-align="center"
                           align="center">
          </el-table-column>
          <el-table-column header-align="center"
                           align="center"
                           label="申请人职位名片信息"
                           min-width="160">
            <template slot-scope="scope">
              <div class="jobCard">
                <img :src="scope.row.jobCard.imgUrl"
                     alt="">
                <img :src="scope.row.jobCard.imgUrl"
                     alt="">
              </div>
            </template>
          </el-table-column>
          <el-table-column header-align="center"
                           label="操作"
                           width="128"
                           align="center"
                           class-name="operation">
            <template slot-scope="scope">

              <el-tooltip v-if="scope.row.id === activeId"
                          effect="dark"
                          content="审核不通过"
                          v-bind:class="scope.row.id === activeId? 'pass':'unpass'"
                          placement="top">
                <el-button @click="handleUnpassClick(scope.row.id)"></el-button>
              </el-tooltip>
              <el-tooltip effect="dark"
                          content="审核通过"
                          placement="top"
                          v-bind:class="scope.row.id === activeId? 'pass':'unpass'"
                          v-else-if="scope.row.id!==activeId">
                <el-button @click="handleSaveClick(scope.row.id)"></el-button>
              </el-tooltip>
              <!-- <el-tooltip
                effect="dark"
                content="审核通过"
                placement="top"
                class="pass"
              >
                <el-button
                  @click="handleSaveClick(scope.row.id)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                effect="dark"
                content="审核不通过"
                placement="top"
                class="unpass"
              >
                <el-button
                  @click="handleUnpassClick(scope.row.id)"
                ></el-button>
              </el-tooltip> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { authorizationList, authorizationAudit } from 'apis/index'
export default {
  data () {
    return {
      id: '',
      data: {
      },
      activeId: ''
    }
  },
  methods: {
    getData (id) {
      authorizationList({
        authorizationId: id
      }).then(res => {
        if (res.data.code === 0) {
          this.data = res.data.data.authorizationList
          this.data.result.forEach(element => {
            if (element.status === '1') {
              this.activeId = element.id
            }
          })
          // console.log(this.activeId)
        }
      })
    },
    handleSaveClick (id) { // 审核通过
      this.activeId = id
    },
    handleUnpassClick () { // 审核不通过
      this.activeId = ''
    },
    handleConfirmClick () { // 保存
      // console.log(this.activeId)
      if (this.activeId) {
        authorizationAudit({
          authorizationId: this.activeId,
          status: 1
        }).then(res => {
          // console.log('aaa', res)
          if (res.data.code === 0) {
            this.$router.push({ path: '/manage/companylist?item=0' })
          }
        })
      } else {
        this.$router.push({ path: '/manage/companylist?item=0' })
      }
    },
    handleCancelClick () { // 取消
      this.$router.push({ path: '/manage/companylist?item=0' })
    }
  },
  mounted () {
    this.id = this.$route.query.item
    this.getData(this.id)
  }
}
</script>
<style lang="stylus">
.authorization
  position absolute
  top 0px
  bottom 20px
  left 20px
  right 20px
  z-index 1
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../assets/images/01/nav_arrow.png') no-repeat top 21px left 81px #F7F9FB
    span
      color #212832
      margin-left 20px
  .main
    width 100%
    background #f7f9fb
    height calc(100% - 50px)
    .authorizationInfo
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../../assets/images/07/shenhei_con.png') no-repeat center left 15px
    .author_table
      width 100%
      height calc(100% - 52px)
      border-top 1px solid #CFD5DC
      background #f7f9fb
      .el-table
        th
          background #e7f0f8
          .cell
            font-size 12px
        td
          .cell
            font-size 12px
          div
            size12()
          .jobCard
            img
              width 106px
              height 70px
              margin-right 20px
          .el-button
            padding 6px 14px
            width 28px
            cursor pointer
            height 28px
            margin 0 8px
          .item
            background url('../../../assets/images/09/icon_pass_n.png') no-repeat
            &:hover
              background url('../../../assets/images/09/icon_pass_h.png') no-repeat
          .pass
            background url('../../../assets/images/09/icon_pass_h.png') no-repeat
            &:hover
              background url('../../../assets/images/09/icon_nopass_h.png') no-repeat
          .unpass
            background url('../../../assets/images/09/icon_nopass_h.png') no-repeat
            &:hover
              background url('../../../assets/images/09/icon_pass_h.png') no-repeat
      .author_btn
        text-align center
        float right
        margin-top 10px
        margin-bottom 10px
        .el-button
          padding 6px 24px
          background #1B88EE
          color #ffffff
          border 1px solid #1B88EE
          margin-right 20px
          &:nth-child(1)
            background #ffffff
            color #1B88EE
</style>
